export default (props, vars) => (event) => {
  vars?.setIsInViewOfferDetailsMode(true);
};
